import { render, staticRenderFns } from "./CustomerOrder.vue?vue&type=template&id=36d3638a&"
import script from "./CustomerOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports